<template>
	<div class="MarketingPlanAdd">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card>
			<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
		</card>
	</div>
</template>
<script>

import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
	name: 'MarketingPlanAdd-page',
	components: {
        ReFormPrinter,
	},
	data() {
		return {
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
		};
	},
	methods: {
		currentFormConfig() {
			let result_id = typeof this.$route.params.plan_id=='undefined'?null:this.$route.params.plan_id;
			this.$GVO.ApiCall('marketing_plan.GET_FORM_MODEL',{flt:{'result_id':result_id}})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
			let result_id = typeof this.$route.params.plan_id=='undefined'?'0':this.$route.params.plan_id;
            return {apiMethod:'marketing_plan.INSUPD',apiParam:{iData:[],flt:{'id':result_id}}};
        },
		SuccessGo(evt,dopParam){
	        this.$router.push({path: '/data/module/mo/marketing_plan'});
			// this.$router.back();
		},
		GoBack(){
			this.$router.back();
		},
	},		
	mounted() {

	}
};
</script>
<style scoped>
.MarketingPlanAdd .bntGroup{
	position: absolute;
	z-index: 1;
	right: 40px;
}
</style>
